import type { QueryKey } from '@tanstack/react-query'

export const queryKeys = {
  filters: (workspaceId: number): QueryKey => ['filter-bar', workspaceId],
  channelFilters: (workspaceId: number): QueryKey => [
    ...queryKeys.filters(workspaceId),
    'channels',
  ],
  labelSetFilters: (workspaceId: number): QueryKey => [
    ...queryKeys.filters(workspaceId),
    'labelSets',
  ],
  storyFilters: (workspaceId: number): QueryKey => [
    ...queryKeys.filters(workspaceId),
    'stories',
  ],
}
